module.exports = __webpack_public_path__ + "static/media/address.5d9b33b0.png";